import { Lock } from 'lucide-react'
import type { NormalizedCollection } from '@wtf/shared'
import { CollectionImage } from './CollectionImage'

interface CollectionListItemProps {
    collection: NormalizedCollection
    onToggle: (collectionId: string) => void
    isProductInCollection?: boolean
}

export function CollectionListItem({ collection, onToggle, isProductInCollection = false }: CollectionListItemProps) {
    return (
        <div
            className={`flex cursor-pointer items-center gap-3 rounded-xl px-2 py-2 transition-colors ${isProductInCollection
                ? 'bg-gray-100 hover:bg-gray-200'
                : 'hover:bg-gray-100'
                }`}
            onClick={() => onToggle(collection.id)}
        >
            <div className="h-12 w-12 shrink-0 overflow-hidden rounded-lg bg-gray-200">
                <CollectionImage collection={collection} />
            </div>
            <div className="min-w-0 flex-1">
                <p className="truncate text-base font-medium text-black">
                    {collection.name}
                </p>
            </div>
            <div className="flex items-center gap-2 shrink-0">

                {collection.isPrivate && (
                    <Lock
                        size={16}
                        className="text-gray-400"
                        aria-label="Private collection"
                    />
                )}
            </div>
        </div>
    )
}
